// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23X-B","tabsBox":"styles_tabsBox__2a4Ey","createButton":"styles_createButton__dP_F7"};